import React from "react";
import { ArrowRight, Calculator, CircleCheck } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndividuellerPreis() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="individueller-preis" className="dark bg-background text-foreground py-24 px-4 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-1/4 right-1/4 w-64 h-64 bg-accent/10 rounded-full blur-3xl" />
      </div>

      <div ref={ref} className={`container mx-auto max-w-4xl relative z-10 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
        <Card className="bg-foreground text-background border-none shadow-2xl overflow-hidden">
          <div className="absolute top-0 left-0 w-2 h-full bg-primary" />
          
          <div className="flex flex-col md:flex-row items-center">
            <div className="flex-1 p-8 md:p-12">
              <CardHeader className="p-0 mb-6">
                <div className="flex items-center gap-3 mb-4 text-primary">
                  <Calculator className="w-6 h-6" />
                  <span className="text-sm font-bold tracking-wider uppercase text-sidebar">
                    Kostenkalkulation
                  </span>
                </div>
                <CardTitle className="text-3xl md:text-4xl font-bold text-sidebar mb-4">
                  Individueller Preis
                </CardTitle>
                <div className="text-primary font-bold text-sm uppercase tracking-wider mb-2">
                  Preis Info
                </div>
                <CardDescription className="text-lg text-sidebar/80">Wir sind in ganz Deutschland sowie in angrenzenden Ländern im Einsatz. Dank sorgfältiger Tourenplanung reinigen wir bis zu 6 Treppen in einer Nacht – ohne Nachtzuschlag. Je früher Sie anfragen, desto besser können wir planen und desto attraktiver fällt Ihr Preis aus. In Einzelfällen sind als Lückenfüller auch besonders günstige Konditionen möglich.</CardDescription>
              </CardHeader>

              <CardContent className="p-0">
                <ul className="space-y-3 mb-8">
                  {["Deutschlandweit & in angrenzenden Ländern unterwegs", "Attraktive Konditionen bei guter Planbarkeit", "Bis zu 6 Treppen pro Nacht", "Keine Nachtzuschläge"].map((item, i) => <li key={i} data-index={i} className="flex items-center gap-3 text-sidebar/90">
                      <CircleCheck className="w-5 h-5 text-primary shrink-0" />
                      <span>{item}</span>
                    </li>)}
                </ul>

                <Link to="/ContactPage">
                  
                </Link>
              </CardContent>
            </div>

            {}
            
          </div>
        </Card>
      </div>
    </section>;
}